module.exports = __webpack_public_path__ + "img/core_competencies.7bebe3a9.jpg";